import React from "react";
import site from "../data/site";

const Stats = () => (
  <section className="stats">
    <div className="container">
      <div className="row">
        {site.stats.map((s) => (
          <div key={s.label} className="stat">
            <div className="value">{s.value}</div>
            <div className="label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
